import Axios from 'axios'

import { message } from 'antd';
import {getPositionsFromData_zd} from "../Pages/GeovisResource/service/actoin";

export const googleImgUrl = `http://${global.earthImgIp}/map_data/googleimg/{z}/{x}/{y}.png`;
export const googleMapUrl = `http://${global.earthImgIp}/map_data/googlemap/{z}/{x}/{y}.png`

// export const googleImgUrl = "http://10.0.35.10/map_data/googleimg/{z}/{x}/{y}.png";
// export const googleMapUrl = "http://10.0.35.10/map_data/googlemap/{z}/{x}/{y}.png"



var currentLayer = googleImgUrl

// ******************************* 1.地球基础功能部分 *******************************

// 改变图层
export function changeLayer() {
    // const earth = window.earth;
    this.layer.removeFrom(window.earth.layers);
    this.currentLayer = this.currentLayer === "img" ? "map" : "img"
    this.layer = new window.GeoVis.TileLayer(currentLayer === "img" ? googleImgUrl : googleMapUrl, {
        projection: 'EPSG:900913'
    }).addTo(window.earth.layers)
}

// 电子地图
export function loadElecEarth() {
    // debugger
    if (window.GeoVis) {
        new window.GeoVis.TileLayer(googleMapUrl, {
            projection: 'EPSG:900913'
        }).addTo(window.earth.layers)
    }
}

// 谷歌影像地图
export function loadGoolgeEarth() {
    if (window.GeoVis) {
        new window.GeoVis.TileLayer(googleImgUrl, {
            projection: 'EPSG:900913'
        }).addTo(window.earth.layers)
    }
}


// 8.暗黑模式
export function loadDarkEarth() {
    if (window.GeoVis) {
        if (false) {
            new window.GeoVis.TileLayer("http://syy.geovisweb.cn:10081/styles/Toner/{z}/{x}/{y}.png", {
                projection: 'EPSG:900913'
            }).addTo(window.earth.layers)
        } else {
            return
        }
    }
}


// 地球视角初始化
export function backEarth() {
    if (window.GeoVis) {
        window.earth.camera.flyHome()
    }
}


// 切换二三维
export function changeScene() {
    if (window.GeoVis) {
        if (window.earth.scene.mode === window.GeoVis.SceneMode.SCENE3D) {
            window.earth.scene.mode = window.GeoVis.SceneMode.SCENE2D   // 三维场景
        } else {
            window.earth.scene.mode = window.GeoVis.SceneMode.SCENE3D   // 三维场景
        }
    }
}


// 加载地名服务
export function loadMapServer() {
    if (window.GeoVis) {
        new window.GeoVis.TileLayer("http://10.0.35.20/tiles/placename/{z}/{x}/{y}.png", {
            projection: "EPSG:900913"
        }).addTo(window.earth.layers)
    }
}

// 缩进视角
export function zoomIn() {
    if (window.GeoVis) {
        window.earth.camera.zoom('in')
    }
}

// 缩远视角
export function zoomOut() {
    if (window.GeoVis) {
        window.earth.camera.zoom('out')
    }
}

// ******************************* 2.drawhelper部分 *******************************

// 测量距离
export function measureDistance() {
    if (window.GeoVis && window.drawHelper) {
        window.drawHelper.startDrawingPolyline({
            color: window.GeoVis.Color.RED.withAlpha(0.5),
            computed: true
        })
    }
}

// 计算面积
export function measureArea() {
    console.log(window.drawHelper, '================================')
    if (window.GeoVis && window.drawHelper) {
        console.log(window.drawHelper, 'aaaaaaaaaaaaaaa=============')
        // window.drawHelper.startDrawingPolygon({
        //     color: window.GeoVis.Color.RED.withAlpha(0.5),
        //     computed: true
        // })
        // setTimeout(() => {
        //     console.log("aaaaaa");
        //     window.earth.features.removeAll();
        // }, 5000);
        var polyOptions = {
            color: window.GeoVis.Color.WHITE.withAlpha(0.8),
            width: 3
        };
        // var Types = window.drawHelper.Types;
        window.drawHelper.startDrawingPolygon({
            type: window.Types.PROJ_POLYGON,
            computed: true,
            ...polyOptions
        });
    }
}

export function measureTerrain() {
    if (window.GeoVis && window.drawHelper) {
        window.drawHelper.startDrawingPolyline({
            color: window.GeoVis.Color.RED.withAlpha(0.9),
            type: window.DrawHelper.Types.GROUND_POLYLINE,
            computed: true,
            length: 5
        })
    }
}

export function measureTerrainArea() {
    if (window.GeoVis && window.drawHelper) {
        window.drawHelper.startDrawingPolygon({
            color: window.GeoVis.Color.RED.withAlpha(0.4),
            type: window.DrawHelper.Types.GROUND_POLYGON,
            computed: true,
            length: 5
        })
    }
}

// 清除draw
export function cleanAll() {
    if (window.GeoVis && window.drawHelper) {
        window.drawHelper.removeAll()
    }
}

// ******************************* 3.数据测试部分 *******************************

// 请求倾斜摄影测试数据
export function showTilesetData() {
    if (window.GeoVis) {
        var tileset = window.earth.scene.primitives.add(new window.GeoVis.GeoVis3DTileset({
            // url: './data/Scene/Production_1.json',
            url: ' http://10.0.35.20/map_data/Scene/Production_1.json',
            maximumScreenSpaceError: 8,
            maximumNumberOfLoadedTiles: 10
        }))
        window.earth.flyTo(tileset)
    }
}

// 请求高程数据
export function showDemData() {

    if (window.GeoVis) {
        window.earth.camera.flyTo({
            destination: window.GeoVis.Vector3.fromDegrees(120.85, 22.7, 9000),
            orientation: {
                pitch: window.GeoVis.Math.toRadians(-20.0), // 俯角
                roll: 0.0 // 旋转角度
            }
        })
        window.earth.scene.terrainProvider = new window.GeoVis.CesiumTerrainProvider({
            // url: "http://10.0.35.20/map_data/dem"
            url: `http://${global.earthImgIp}1/map_data/dem`
        })
    }
}

// 上海影像数据
export function showShData() {
    if (window.GeoVis) {
        new window.GeoVis.TileLayer("http://10.0.35.20/geoserver/gwc/service/tms/1.0.0/work%3Ashanghai_Level_18@EPSG%3A4326@png/{z}/{x}/{reverseY}.png", {
            projection: 'EPSG:4326'
        }).addTo(window.earth.layers)

        window.earth.camera.flyTo({
            destination: window.GeoVis.Vector3.fromDegrees(121.5, 31.15, 9e4)
        })
    }
}

// world区划
export function worldGEOJSON() {
    if (window.GeoVis) {
        new window.GeoVis.GeoJSON('http://10.10.50.109/world/world.geojson', {
            batch: true,
            style: {
                outlineColor: window.GeoVis.Color.YELLOW,
                outline: true,
                fill: false,
                fillColor: window.GeoVis.Color.RED.withAlpha(0.0),
                outlineWidth: 5.0,
                async: true,
                transparent: true
            }
        }).addTo(window.earth)
    }
}

export function ChinaGEOJSON() {
    if (window.GeoVis) {
        new window.GeoVis.GeoJSON('http://10.10.50.109:8080/china/china.geojson', {
            batch: true,
            style: {
                outlineColor: window.GeoVis.Color.YELLOW,
                outline: true,
                fill: false,
                fillColor: window.GeoVis.Color.RED.withAlpha(0.0),
                outlineWidth: 5.0,
                async: true,
                transparent: true
            }
        }).addTo(window.earth)
    }
}

// 三维模型的加载
export function createModel(url, position) {
    if (window.GeoVis) {

        // var vec = window.GeoVis.Vector3.fromDegrees(120.76899, 31.2914, 0);
        var vec = window.GeoVis.Vector3.fromDegrees(position[0], position[1], 0);
        var modelMatrix = window.GeoVis.Transforms.eastNorthUpToFixedFrame(vec);
        var model = window.GeoVis.Model.fromGltf({
            url: url,
            modelMatrix: modelMatrix,
            scale: 0.3,
        }).addTo(window.earth.features)

        model.readyPromise.then(function (model) {
            model.activeAnimations.addAll({
                loop: window.GeoVis.ModelAnimationLoop.REPEAT
            });
        })

        window.earth.camera.setView({
            // destination: window.GeoVis.Vector3.fromDegrees(120.766699, 31.2914, 100),
            destination: window.GeoVis.Vector3.fromDegrees(position[0] - 0.002, position[1], 100),

            orientation: {
                heading: window.GeoVis.Math.toRadians(90.0),
                pitch: window.GeoVis.Math.toRadians(-20)
            }
        })
    }
}

var layersInfolist = {}
var polygonList = {}
// 测试Tiff切片2.0

export function showTiffTile(testUrl, fileid, visiable) {
    var layersInfo;

    if (visiable) {
        Axios.get(testUrl)
            .then(res => {

                if (res.config.url === '') {
                    message.warning('正在切片,请稍后...')
                    return
                }
                const data = res.config.url.split("?")


                if (data === '') {
                    message.warning('正在切片,请稍后...')
                }

                // 1.展示切片
                layersInfo = new window.GeoVis.TileLayer(data[0], {

                    projection: 'EPSG:4326'
                }).addTo(window.earth.layers)

                // 2.获得范围
                var area = data[1].split("=")[1].split("%")
                area = area.map(item => {
                    return parseFloat(item)
                })


                var posX = (area[0] + area[2]) / 2.0
                var posY = (area[1] + area[3]) / 2.0
                layersInfo.fileid = fileid

                // 3.fly
                window.earth.flyTo([posX, posY, 500000])

                // 4.画框
                var polygon = showBorder(area)
                layersInfolist[fileid] = layersInfo
                polygonList[fileid] = polygon
            })
    } else {

        if (layersInfolist[fileid] && polygonList[fileid]) {
            layersInfolist[fileid].visible = false
            polygonList[fileid].visible = false
        }
    }
}

// ******************************* 4.开启编辑模式 *******************************

export function pickScene(event) {
    if (window.GeoVis) {
        // console.log(event)
        if (event.lonlat) {
            var lon = event.lonlat[0].toFixed(4);
            var lat = event.lonlat[1].toFixed(4);
            var height = event.lonlat[2].toFixed(4);
        }

        if (event.type === "mouseMove") {
            var lngLatInfo = document.getElementById('lngLatInfo');
            lngLatInfo.innerText = `经度: ${lon} 纬度: ${lat} 高度: ${height}`
        } else if (event.type === "click") {
            console.log(event.position)

            // // 服务器传过来的  现在这里是假数据
            var positions = [[lon - 5, lat - 5], [parseFloat(lon) + 5, lat - 5], [parseFloat(lon) + 5, parseFloat(lat) + 5], [lon - 5, parseFloat(lat) + 5]]; // 左下经度，左下纬度，右上经度，右上纬度
            console.log(positions)
            //(1) 先把经纬度转成笛卡尔坐标 
            var carPoisitions = positions.map(position => {
                return window.GeoVis.Cartesian3.fromDegrees(position[0], position[1])
            })
            console.log(carPoisitions)

            // (2) 计算
            var area = (window.DrawHelper.computeArea(carPoisitions) / 1000).toFixed(2)
            console.log(area)

            // (3.1)展示边框
            new window.GeoVis.Polygon(positions, {
                outline: true,
                outlineColor: window.GeoVis.Color.fromCssString("#ff0000").withAlpha(0.5),
                fill: false,
                fillColor: window.GeoVis.Color.fromCssString("#512da8").withAlpha(0.5),
                extrudedHeight: 10,
                outlineWidth: 2
            }).addTo(window.earth.features)

            // (3.2)展示dom
            var marker = new window.GeoVis.Marker([+(lon), +(lat), +(height)]).addTo(window.earth.features);
            marker.bindPopup(`面积为:${area}平方米`, {
                maxWidth: 120
            })

            var closeBtns = document.getElementsByClassName("gv-popup-close")
            for (let i = 0; i < closeBtns.length; i++) {
                closeBtns[i].href = "javascript:void(0)"
            }

            marker.showPopup();
        }
    }
}



//  其他


// 展示边界     pos为:[左下经度，左下纬度，右上经度，右上纬度]
export function showBorder(pos) {
    let border = [[pos[0], pos[1]], [pos[2], pos[1]], [pos[2], pos[3]], [pos[0], pos[3]]]

    return new window.GeoVis.Polygon(border, {
        outline: true,
        outlineColor: window.GeoVis.Color.fromCssString("#ff0000").withAlpha(0.5),
        fill: false,
        fillColor: window.GeoVis.Color.fromCssString("#512da8").withAlpha(0.5),
        extrudedHeight: 10,
        outlineWidth: 2
    }).addTo(window.earth.features)
}


var picLayer = {}
/**
 *
 * @param {*} url 图片路径
 * @param {*} positions 图片四个点的经纬度,分别是上左、上右、下右、下左
 * @param {*} checkedArr 选择列表
 * @param {*} checkedIndex 所选数据的序号
 * @param geom 为视角移动相关函数提供参数的数据
 * @param flyTo 是否进行视角移动
 */
// 出问题了，picLayer的内容是一样的，不知道是哪里的问题
export function showPic(url, positions, checkedArr, checkedIndex,geom, flyTo = false) {
    let { Geovis, earth } = window
    console.log('cccc', positions)
    let newUrl = url.replace("http://10.0.121.14:8084", "/zdTiles")
    console.log("贴图url：", newUrl);
    // console.log('检查参数:',url, positions, checkedArr, checkedIndex,)
    if (!checkedArr[checkedIndex][2]) {

        if (positions.length === 4) {
            console.log('检查坐标点',positions)
            picLayer = window.earth.imageryLayers.addImageryProvider(
                new window.Geovis.SingleTileImageryProvider({
                    url: newUrl,
                    rectangle: new window.Geovis.Rectangle.fromDegrees(positions[0], positions[1], positions[2], positions[3])
                    // rectangle:new window.Geovis.Rectangle.fromDegrees(12.21, 12.21, 12.21, 12.21)
                })
            )
        } else {
            const flattenedPositions = positions.flat();
            // console.log("排查报错代码",Geovis.Cartesian3.fromDegreesArray(flattenedPositions));
            var polygon = new Geovis.GeometryInstance({
                geometry: new Geovis.PolygonGeometry({
                    polygonHierarchy: new Geovis.PolygonHierarchy(
                        Geovis.Cartesian3.fromDegreesArray(flattenedPositions)
                    ),
                }),
            });

            var polygonAppearance = new Geovis.MaterialAppearance({
                material: Geovis.Material.fromType(Geovis.Material.ImageType, {
                    image: newUrl
                })
            });

            picLayer = new Geovis.GroundPrimitive({
                geometryInstances: polygon,
                appearance: polygonAppearance,
            });

            // picLayer._zindex = earth.scene.primitives.length + 1
            earth.scene.primitives.add(picLayer);


        }
        if (flyTo) {
            let fly_positions = getPositionsFromData_zd(geom);

            window.earth.camera.flyTo({
                destination: window.Geovis.Cartesian3.fromDegrees((fly_positions[0] + fly_positions[2]) / 2.0, (fly_positions[1] + fly_positions[3]) / 2.0, 400000)
            })
            // window.earth.camera.flyTo({
            //     destination: window.Geovis.Cartesian3.fromDegrees((positions[0] + positions[2]) / 2.0, (positions[1] + positions[3]) / 2.0, 400000)
            // })
        }
        // console.log(picLayer)
    } else {
        // checkedArr[checkedIndex][0].show = false
        if (positions.length === 4)
            window.earth.imageryLayers.remove(checkedArr[checkedIndex][0]);
        else
            earth.scene.primitives.remove(checkedArr[checkedIndex][0]);
    }
    // console.log("排查报错代码");
    checkedArr[checkedIndex] = [picLayer, {}, !checkedArr[checkedIndex][2]]
}


export function addPicToEarth(url, positions, flyTo = false) {
    let { Geovis, earth } = window
    let newUrl = url.replace("http://10.0.121.14:8084", "/zdTiles")
    let picLayer = {}
    if (positions.length === 4) {
        picLayer = window.earth.imageryLayers.addImageryProvider(
            new window.Geovis.SingleTileImageryProvider({
                url: newUrl,
                rectangle: new window.Geovis.Rectangle.fromDegrees(positions[0], positions[1], positions[2], positions[3])
                // rectangle:new window.Geovis.Rectangle.fromDegrees(12.21, 12.21, 12.21, 12.21)
            })
        )
    } else {
        var polygon = new Geovis.GeometryInstance({
            geometry: new Geovis.PolygonGeometry({
                polygonHierarchy: new Geovis.PolygonHierarchy(
                    Geovis.Cartesian3.fromDegreesArray(positions)
                ),
            }),
        });
        var polygonAppearance = new Geovis.MaterialAppearance({
            material: Geovis.Material.fromType(Geovis.Material.ImageType, {
                image: newUrl
            })
        });
        picLayer = new Geovis.GroundPrimitive({
            geometryInstances: polygon,
            appearance: polygonAppearance,
        });
        earth.scene.primitives.add(picLayer);
    }
    if (flyTo) {
        window.earth.camera.flyTo({
            destination: window.Geovis.Cartesian3.fromDegrees((positions[0] + positions[2]) / 2.0, (positions[1] + positions[3]) / 2.0, 400000)
        })
    }
    return picLayer
}

export function showPicAtOrder(url, positions, openFlag, index) {
    console.log('ceshi', openFlag)
    if (!openFlag[index][1]) {
        console.log("positions", positions)
        picLayer = window.earth.imageryLayers.addImageryProvider(
            new window.Geovis.SingleTileImageryProvider({
                url: url,
                rectangle: new window.Geovis.Rectangle.fromDegrees(positions[0], positions[1], positions[2], positions[3])
                // rectangle:new window.Geovis.Rectangle.fromDegrees(12.21, 12.21, 12.21, 12.21)
            })
        )
        window.earth.camera.flyTo({
            destination: window.Geovis.Cartesian3.fromDegrees((positions[0] + positions[2]) / 2.0, (positions[1] + positions[3]) / 2.0, 400000)
        })
    } else {
        // checkedArr[checkedIndex][0].show = false
        window.earth.imageryLayers.remove(openFlag[index][0]);
    }

    let temp = [picLayer, !openFlag[index][1]]
    return temp
}


var picLayer2, polygonTest2, statusPic2 = false
/**
 * 
 * @param {*} url 图片路径
 * @param {*} positions 图片四个点的经纬度,分别是上左、上右、下右、下左
 * @param {*} checkedArr 选择列表
 * @param {*} checkedIndex 所选数据的序号
 */
export function showPicForOne(url, positions, checkedArr, checkedIndex) {
    let newUrl = url.replace("http://10.0.121.14:8084", "/zdTiles")

    // picLayer2 = new window.GeoVis.SingleLayer(newUrl, {
    //     rectangle: new window.GeoVis.Rectangle.fromDegrees(positions[0], positions[1], positions[2], positions[3])
    // }).addTo(window.earth.layers);
    picLayer2 = window.earth.imageryLayers.addImageryProvider(
        new window.Geovis.SingleTileImageryProvider({
            url: newUrl,
            rectangle: new window.Geovis.Rectangle.fromDegrees(positions[0], positions[1], positions[2], positions[3])
        })
    )
    checkedArr[checkedIndex] = [picLayer2, polygonTest2, true];
}


// 其他

var showSelectArea = false
// 1.自定义区域
export function selectArea() {

    if (!showSelectArea) {
        document.getElementById("lngLatInfo").style.display = "block"
        window.earth.on("mouseMove", pickScene)
    } else {
        document.getElementById("lngLatInfo").style.display = "none"
        window.earth.off("mouseMove", pickScene)
    }
    showSelectArea = !showSelectArea
}


// 2. 多边形框选

export function selectPolygon() {
    window.drawHelper.startDrawingPolygon({
        color: window.GeoVis.Color.BLUE.withAlpha(0.5)
    })
}


// export function addTiff()  {
//     console.log('new window.GeoVis', window.GeoVis)

//     var tiffLayer = new window.GeoVis.GeoTiffLayer(`${window.sliceServersUrl.baseUrl}/images/GF1_PMS1_E109.3_N50.2_20211228_L1A0006175494-MSS1.tiff`, {
//       samples: [0],
//       extensions: 'png',
//       noData: [255]
//     }).addTo(window.earth.layers)
//     window.earth.camera.flyTo({
//       destination: window.GeoVis.Cartesian3.fromDegrees(109.153, 50.3704, 15000.0)
//     });
//     console.log(tiffLayer)

//   }



